import PrintShell, { PrintField, PrintRow, PrintSectionHeader, PrintTextBlock } from '../../../components/print/PrintShell';

export default function AnnouncementPrintTemplate({ announcement: a }) {
  if (!a) return null;
  return (
    <PrintShell printClass="announcement-print-only" formTitle="ANNOUNCEMENT">
      <PrintSectionHeader title="Announcement" />
      <PrintField label="Title" value={a.title} />
      <PrintRow fields={[
        { label: 'Active', value: a.active ? 'Yes' : 'No', flex: 0.4 },
        { label: 'Expires At', value: a.expires_at },
      ]} />
      <PrintTextBlock label="Body" value={a.body} />
    </PrintShell>
  );
}
